import iconoTitulo from "../../static/images/Gamificacion/Reconocimientos de la confianza/icono titulo.png";
import bannerCredibilidad from "../../static/images/Gamificacion/Reconocimientos de la confianza/generamos credibilidad.png";
import iconoCredibilidad from "../../static/images/Gamificacion/Reconocimientos de la confianza/icono generamos credibilidad.png";
import bannerVinculos from "../../static/images/Gamificacion/Reconocimientos de la confianza/forjamos vinculos.png";
import iconoVinculos from "../../static/images/Gamificacion/Reconocimientos de la confianza/icono forjamos vinculos.png";
import bannerRed from "../../static/images/Gamificacion/Reconocimientos de la confianza/trabajamos en red.png";
import iconoRed from "../../static/images/Gamificacion/Reconocimientos de la confianza/icono trabajamos en red.png";
import bannerPrometemos from "../../static/images/Gamificacion/Reconocimientos de la confianza/somos lo que prometemos.png";
import iconoPrometemos from "../../static/images/Gamificacion/Reconocimientos de la confianza/icono somos lo que prometemos.png";

export const TRUST_GREEN = "#93d500";

export { iconoTitulo };

const normalizar = (texto = "") =>
    texto
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase();

// Los 4 pilares (e imágenes) siempre se pintan, existan o no filas en tbl_Listas.
// El texto viene de la lista dinámica (Reconocimiento_Motivos) cuando existe y
// "nombre" queda como respaldo. Como el texto de la BD no siempre coincide
// palabra por palabra con el nombre oficial, la asociación se hace por palabras
// clave, igual que el backend (functions/pilaresReconocimiento.js).
export const PILARES = [
    {
        codigo: "credibilidad",
        nombre: "Generamos credibilidad",
        match: (p) => p.includes("generamos") && p.includes("credibilidad"),
        banner: bannerCredibilidad,
        icono: iconoCredibilidad,
    },
    {
        codigo: "vinculos",
        nombre: "Forjamos vínculos sólidos y duraderos",
        match: (p) => p.includes("vinculos") && p.includes("solidos"),
        banner: bannerVinculos,
        icono: iconoVinculos,
    },
    {
        codigo: "red",
        nombre: "Trabajamos en red, logramos resultados y evolucionamos juntos",
        match: (p) => p.includes("trabajamos") && p.includes("red"),
        banner: bannerRed,
        icono: iconoRed,
    },
    {
        codigo: "prometemos",
        nombre: "Somos lo que prometemos",
        match: (p) => p.includes("prometemos"),
        banner: bannerPrometemos,
        icono: iconoPrometemos,
    },
];

// Combina los pilares fijos con la lista dinámica: si la BD trae el pilar, se usa
// su texto (descripcion) y su código; si no, el nombre de respaldo.
export const resolverPilares = (listaBD) => {
    const lista = Array.isArray(listaBD) ? listaBD : [];

    return PILARES.map((pilar) => {
        const itemBD = lista.find((item) => pilar.match(normalizar(item.codigo)));

        return {
            ...pilar,
            nombre: itemBD?.descripcion || pilar.nombre,
            codigoBD: itemBD?.codigo,
        };
    });
};

// Reconocimientos (items con propiedad "pilar") que pertenecen al pilar indicado.
export const filtrarPorPilar = (recognitions, pilar) =>
    recognitions.filter(
        (r) => r.pilar === pilar.codigoBD || pilar.match(normalizar(r.pilar))
    );
